import{defineMessages}from'react-intl';

export default defineMessages({
title_default:{
id:'success_modal.title_default',
defaultMessage:'Success!'},

success_message:{
id:'success_modal.success_message',
defaultMessage:'Your mass action should now be reflected in the report table.'},

close:{
id:'success_modal.close',
defaultMessage:'Close'},

title_error:{
id:'success_modal.title_error',
defaultMessage:'Error'},

error_message:{
id:'success_modal.error_message',
defaultMessage:'An error occurred. Please try again.'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL01hc3NBY3Rpb25TdWNjZXNzTW9kYWwvTWFzc0FjdGlvblN1Y2Nlc3NNb2RhbC5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsInRpdGxlX2RlZmF1bHQiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwic3VjY2Vzc19tZXNzYWdlIiwiY2xvc2UiLCJ0aXRsZV9lcnJvciIsImVycm9yX21lc3NhZ2UiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLGNBQWU7QUFDYkMsR0FBSSw2QkFEUztBQUViQyxlQUFnQixVQUZILENBRGE7O0FBSzVCQyxnQkFBaUI7QUFDZkYsR0FBSSwrQkFEVztBQUVmQyxlQUFnQiwrREFGRCxDQUxXOztBQVM1QkUsTUFBTztBQUNMSCxHQUFJLHFCQURDO0FBRUxDLGVBQWdCLE9BRlgsQ0FUcUI7O0FBYTVCRyxZQUFhO0FBQ1hKLEdBQUksMkJBRE87QUFFWEMsZUFBZ0IsT0FGTCxDQWJlOztBQWlCNUJJLGNBQWU7QUFDYkwsR0FBSSw2QkFEUztBQUViQyxlQUFnQixzQ0FGSCxDQWpCYSxDQUFmLENBQWYiLCJmaWxlIjoiTWFzc0FjdGlvblN1Y2Nlc3NNb2RhbC5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICB0aXRsZV9kZWZhdWx0OiB7XG4gICAgaWQ6ICdzdWNjZXNzX21vZGFsLnRpdGxlX2RlZmF1bHQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU3VjY2VzcyEnLFxuICB9LFxuICBzdWNjZXNzX21lc3NhZ2U6IHtcbiAgICBpZDogJ3N1Y2Nlc3NfbW9kYWwuc3VjY2Vzc19tZXNzYWdlJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1lvdXIgbWFzcyBhY3Rpb24gc2hvdWxkIG5vdyBiZSByZWZsZWN0ZWQgaW4gdGhlIHJlcG9ydCB0YWJsZS4nLFxuICB9LFxuICBjbG9zZToge1xuICAgIGlkOiAnc3VjY2Vzc19tb2RhbC5jbG9zZScsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdDbG9zZScsXG4gIH0sXG4gIHRpdGxlX2Vycm9yOiB7XG4gICAgaWQ6ICdzdWNjZXNzX21vZGFsLnRpdGxlX2Vycm9yJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0Vycm9yJyxcbiAgfSxcbiAgZXJyb3JfbWVzc2FnZToge1xuICAgIGlkOiAnc3VjY2Vzc19tb2RhbC5lcnJvcl9tZXNzYWdlJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0FuIGVycm9yIG9jY3VycmVkLiBQbGVhc2UgdHJ5IGFnYWluLicsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/MassActionSuccessModal/MassActionSuccessModal.messages.js
// module id = 2268
// module chunks = 0